module.exports = __webpack_public_path__ + "static/media/metamask.78162004.svg";